import { createI18n } from 'vue-i18n'
import { settings } from '@/scripts/services/SettingsService'
import en from './locales/en'
import es from './locales/es'
import ja from './locales/ja'
import kk from './locales/kk'
import ko from './locales/ko'
import pt from './locales/pt'
import ru from './locales/ru'
import tr from './locales/tr'
import vi from './locales/vi'
import zh from './locales/zh'

const FALLBACK_LOCALE = 'en'

const messages = {
  en,
  es,
  ja,
  kk,
  ko,
  pt,
  ru,
  tr,
  vi,
  zh
}

const availableLocales = [
  { code: 'en', label: 'English', nativeName: 'English' },
  { code: 'es', label: 'Spanish', nativeName: 'Español' },
  { code: 'zh', label: 'Chinese', nativeName: '中文' },
  { code: 'pt', label: 'Portuguese', nativeName: 'Português' },
  { code: 'ja', label: 'Japanese', nativeName: '日本語' },
  { code: 'ko', label: 'Korean', nativeName: '한국어' },
  { code: 'vi', label: 'Vietnamese', nativeName: 'Tiếng Việt' },
  { code: 'kk', label: 'Kazakh', nativeName: 'Қазақша' },
  { code: 'tr', label: 'Turkish', nativeName: 'Türkçe' },
  { code: 'ru', label: 'Russian', nativeName: 'Русский' }
]

function normalizeLocale(locale) {
  if (!locale || typeof locale !== 'string') return null
  const normalized = locale.toLowerCase().split('-')[0]
  return messages[normalized] ? normalized : null
}

function detectLocale() {
  const savedLocale = normalizeLocale(settings.get('locale'))
  if (savedLocale) return savedLocale

  const candidates = navigator.languages?.length ? navigator.languages : [navigator.language]
  for (const candidate of candidates) {
    const locale = normalizeLocale(candidate)
    if (locale) return locale
  }

  return FALLBACK_LOCALE
}

const i18n = createI18n({
  legacy: true,
  locale: detectLocale(),
  fallbackLocale: FALLBACK_LOCALE,
  messages
})

function setDocumentLocale(locale) {
  document.documentElement.lang = locale
}

function setLocale(locale) {
  const nextLocale = normalizeLocale(locale) || FALLBACK_LOCALE
  i18n.global.locale = nextLocale
  settings.set('locale', nextLocale)
  setDocumentLocale(nextLocale)
}

settings.subscribe((key, value) => {
  if (key !== 'locale') return

  const nextLocale = normalizeLocale(value) || FALLBACK_LOCALE
  if (i18n.global.locale === nextLocale) return

  i18n.global.locale = nextLocale
  setDocumentLocale(nextLocale)
})

function t(key, params = {}) {
  return i18n.global.t(key, params)
}

setDocumentLocale(i18n.global.locale)

export { availableLocales, i18n, setLocale, t }
